import { gsap } from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../../helpers/initScrollTrigger';
// import Lottie from 'lottie-web';

// import сustomPageScroll from './../custom-scroll';
import initVideoSection from './video-text-section';
// import initTextSectionAnims from './text-section';
import initCardsSectionAnims from './cards-section';

// import { getNewLottieAnim } from '../../helpers/lottie';
import { IS_HOME_VERTICAL } from '../../helpers/consts';

// import initHeroAnims from './hero';

gsap.registerPlugin(ScrollTrigger);

const globalHorPixelDuration = 5000;

// const getDistanceToSection = (sections, sectionIndex) => {
// 	let distance = 0;
// 	// const ww = document.documentElement.clientWidth;

// 	sections.forEach((section, i) => {
// 		if(i < sectionIndex) {
// 			const rect = section.getBoundingClientRect();
// 			distance = distance + Math.floor(rect.width);
// 		}
// 	});

// 	// if(isPrevScrolling) {
// 	// 	const rect = this.sections[sectionIndex].getBoundingClientRect();
// 	// 	const w = Math.ceil(rect.width);
// 	// 	if(isHorizontal) {
// 	// 		if(w > ww) {
// 	// 			distance = distance + w - ww;
// 	// 		}
// 	// 	}
// 	// }
// 	return distance;
// }


// const calcValueToHorScroll = (value, duration) => {
// 	// const ww = window.innerWidth;
// 	// const finalValue = (value * ww) / duration;
// 	// return finalValue;
// }
let globalHorWidth = 0;
const getAllSectionWidth = (sections) => {
	const ww = window.innerWidth;
	let width = 0;
	sections.forEach(section => {
		width += section.offsetWidth;
	});
	const finalW = width - ww;

	globalHorWidth = finalW;
	return finalW;
};
const getAllSectionHeight = (sections) => {
	const wh = window.innerHeight;
	let Height = 0;
	sections.forEach(section => {
		Height += section.offsetHeight;
	});
	const finalW = Height - wh;
	// globalHorHeight = finalW;
	return finalW;
};
const tweens = [];

const sceneMoved = 0;



const initAnimContainerAnims = () => {
	if(IS_HOME_VERTICAL) return;
	const container = document.querySelector('.js-home-anim-container');
	if(container) {
		const containerInner = container.querySelector('.js-home-anim-container-inner');

		ScrollTrigger.create({
			trigger: container,
			horizontal: true,
			start: 'left left',
			end: 'right right',

			onEnter: () => {
			},
			onUpdate: (self) => {
				const progress = self.progress;
				const distanceX = container.offsetWidth - containerInner.offsetWidth;
				const distanceY = container.offsetHeight - containerInner.offsetHeight;
				gsap.set(containerInner, {
					force3D: true,
					x: distanceX * progress,
					y: distanceY * progress,
				});
			},
		});
	}
};

export default () => {
	initScrollTrigger();

	// initHeroAnims();
	// initTextSectionAnims();
	initAnimContainerAnims();
	initVideoSection();
	initCardsSectionAnims();
};
